import { useState, useRef, useCallback } from 'react';

export type ToastVariant = 'success' | 'error';

export interface ToastState {
    visible: boolean;
    message: string;
    variant: ToastVariant;
}

export interface ToastApi extends ToastState {
    show: (message: string, durationMs?: number, variant?: ToastVariant) => void;
    dismiss: () => void;
}

export function useToast(): ToastApi {
    const [state, setState] = useState<ToastState>({ visible: false, message: '', variant: 'success' });
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const dismiss = useCallback(() => {
        if (timerRef.current) clearTimeout(timerRef.current);
        setState(s => ({ ...s, visible: false }));
    }, []);

    const show = useCallback((message: string, durationMs = 1500, variant: ToastVariant = 'success') => {
        if (timerRef.current) clearTimeout(timerRef.current);
        setState({ visible: true, message, variant });
        if (variant === 'success') {
            timerRef.current = setTimeout(() => setState(s => ({ ...s, visible: false })), durationMs);
        }
    }, []);

    return { ...state, show, dismiss };
}
